import { render, staticRenderFns } from "./FormElementInstruction.vue?vue&type=template&id=480bcade"
import script from "./FormElementInstruction.vue?vue&type=script&lang=js"
export * from "./FormElementInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports